import { useEffect, useRef } from 'react';
import styles from './HikerCharacter.module.css';

export default function HikerCharacter({ heroRef }) {
  const hikerRef = useRef(null);
  const imgRef = useRef(null);
  const posRef = useRef({ x: 0, y: 0, targetX: 0, targetY: 0, isMoving: false });
  const animRef = useRef(null);
  const directionRef = useRef(1); // 1 for right, -1 for left
  const mouseMovingRef = useRef(false);
  const mouseTimerRef = useRef(null);

  useEffect(() => {
    const hiker = hikerRef.current;
    const img = imgRef.current;
    if (!hiker || !img || !heroRef?.current) {
      console.log('HikerCharacter: Missing refs', { hiker, img, heroRef: heroRef?.current });
      return;
    }

    const hero = heroRef.current;
    const hikerWidth = 50;
    const hikerHeight = 60;
    const lerp = 0.06;

    // Frame paths - using PUBLIC_URL for Create React App
    const publicUrl = process.env.PUBLIC_URL || '';
    const frames = [
      `${publicUrl}/hiker_frame_1.png`,
      `${publicUrl}/hiker_frame_2.png`,
      `${publicUrl}/hiker_frame_3.png`,
    ];

    console.log('Frames:', frames);
    console.log('Setting initial image:', frames[0]);
    
    // Set initial image
    img.src = frames[0];

    // Function to calculate badge position and dimensions
    const getBadgePosition = () => {
      const badge = hero.querySelector('[class*="Badge"], [class*="badge"]') || 
                    Array.from(hero.querySelectorAll('div')).find(el => 
                      el.textContent.includes("HIKING COMMUNITY") || el.textContent.includes("#1")
                    );
      
      if (badge) {
        const rect = badge.getBoundingClientRect();
        const heroRect = hero.getBoundingClientRect();
        const relativeLeft = rect.left - heroRect.left;
        const relativeTop = rect.top - heroRect.top;
        const width = rect.width;
        const height = rect.height;
        return {
          x: relativeLeft,
          y: relativeTop,
          width: width,
          height: height,
          found: true
        };
      }
      
      // Fallback: estimate badge position
      return {
        x: hero.offsetWidth * 0.25,
        y: hero.offsetHeight * 0.065,
        width: hero.offsetWidth * 0.5,
        height: 60,
        found: false
      };
    };

    const getBadgeCoordinates = () => {
      const badgeInfo = getBadgePosition();
      return {
        badgeCenterY: badgeInfo.y - hikerHeight - 5,
        badgeLeftX: badgeInfo.x,
        badgeRightX: badgeInfo.x + badgeInfo.width - hikerWidth
      };
    };

    // let badgeCoords = getBadgeCoordinates();

    // Function to calculate home position (badge center)
    const calculateHomePosition = () => {
      const { badgeLeftX, badgeRightX, badgeCenterY } = getBadgeCoordinates();
      const homeX = (badgeLeftX + badgeRightX) / 2;
      const homeY = badgeCenterY;
      return { homeX, homeY };
    };

    // Home position (center of badge)
    let { homeX, homeY } = calculateHomePosition();

    posRef.current.x = homeX;
    posRef.current.y = homeY;
    posRef.current.targetX = homeX;
    posRef.current.targetY = homeY;

    // Auto-walk state
    let autoWalkTimer = null;
    let walkDirection = 1; // 1 for right, -1 for left
    let walkProgress = 0.5; // 0 to 1, starts at center
    const walkStepSize = 0.01; // Small step size for smooth walking
    const minWalkSteps = 8; // Minimum steps before stopping

    // Walking frames: frame 1 and frame 3 — Idle frame: frame 2
    const walkFrames = [frames[0], frames[2]];
    let walkIndex = 0;
    let frameTimer = 0;
    let footprintTimer = 0;
    const footprints = [];

    const spawnFootprint = (x, y) => {
      const isLeft = walkIndex === 0;
      const fp = document.createElement('div');
      fp.style.cssText = `
        position: absolute;
        left: ${x + hikerWidth / 2 + (isLeft ? -10 : 4)}px;
        top: ${y + hikerHeight - 6}px;
        width: 12px;
        height: 6px;
        border-radius: 50%;
        background: rgba(255, 240, 200, 0.75);
        box-shadow: 0 0 5px rgba(255, 220, 150, 0.5);
        pointer-events: none;
        z-index: 5;
        opacity: 0.9;
        transition: opacity 6s ease;
      `;
      hero.appendChild(fp);
      footprints.push(fp);
      requestAnimationFrame(() => { fp.style.opacity = '0'; });
      setTimeout(() => {
        if (fp.parentNode) fp.parentNode.removeChild(fp);
        footprints.splice(footprints.indexOf(fp), 1);
      }, 6000);
    };

    const messages = [
      "Let's go on a trip! 🥾",
      "Do you dream of hiking? 🏔️",
      "Jordan is calling you...",
      "The trail awaits! 🌿",
      "Adventure is out there!",
      "One step at a time 👣",
      "Fresh air. Clear mind.",
      "Wadi Rum is magical ✨",
      "Book your next hike!",
      "Nature is the best therapy 🌄",
      "Walk more, worry less",
      "Petra is worth every step 🪨",
      "Ready for the wild? 🦅",
      "Every summit has a story",
      "Life is better on the trail 🌲",
    ];

    let bubbleEl = null;
    let bubbleTimeout = null;

    const showBubble = (x, y, onDismiss) => {
      if (bubbleEl) { bubbleEl.remove(); bubbleEl = null; }
      if (bubbleTimeout) clearTimeout(bubbleTimeout);

      const msg = messages[Math.floor(Math.random() * messages.length)];

      const b = document.createElement('div');
b.style.cssText = `
  position: absolute;
  left: ${x + hikerWidth - 35}px;
  top: ${y - 115}px;
  width: 135px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 200;
  opacity: 0;
  transform: translateY(8px) scale(0.85);
  transition: opacity 0.35s ease, transform 0.35s ease;
`;

      const cloudImg = document.createElement('img');
      cloudImg.src = `${publicUrl}/thought.png`;
      cloudImg.style.cssText = `
        position: absolute;
        top: 0; left: 0;
        width: 100%; height: 100%;
        object-fit: contain;
        pointer-events: none;
        opacity: 0.65;
      `;

  const text = document.createElement('div');
text.innerText = msg;
text.style.cssText = `
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  width: 65%;
  height: 65%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  font-family: 'Alvareo', 'Segoe UI', sans-serif;
  color: #1a3a1a;
  font-weight: 600;
  line-height: 1.5;
  white-space: normal;
  word-break: break-word;
  pointer-events: none;
  opacity: 0.85;
`;

      b.appendChild(cloudImg);
      b.appendChild(text);
      hero.appendChild(b);
      bubbleEl = b;

      // Delay showing bubble by 1 second
      setTimeout(() => {
        requestAnimationFrame(() => {
          b.style.opacity = '1';
          b.style.transform = 'translateY(0) scale(1)';
        });
      }, 1000);

      // Hide and dismiss after 5 seconds (from when it appears)
      bubbleTimeout = setTimeout(() => {
        b.style.opacity = '0';
        b.style.transform = 'translateY(-6px) scale(0.9)';
        setTimeout(() => { 
          if (b.parentNode) b.remove(); 
          if (bubbleEl === b) bubbleEl = null; 
          // Call the dismissal callback
          if (onDismiss) onDismiss();
        }, 400);
      }, 5000 + 1000); // 5 seconds display + 1 second initial delay
    };

    const hideBubble = () => {
      if (bubbleTimeout) clearTimeout(bubbleTimeout);
      if (bubbleEl) {
        bubbleEl.style.opacity = '0';
        const b = bubbleEl;
        bubbleEl = null;
        setTimeout(() => { if (b.parentNode) b.remove(); }, 300);
      }
    };

    // Handle window resize to keep position responsive
    const handleResize = () => {
      const { homeX: newHomeX, homeY: newHomeY } = calculateHomePosition();
      homeX = newHomeX;
      homeY = newHomeY;
      // Return to home position when resizing
      posRef.current.targetX = newHomeX;
      posRef.current.targetY = newHomeY;
    };

    // Start idle
    img.src = frames[1];

    const updatePosition = () => {
      const { x, y, targetX, targetY } = posRef.current;

      // Smoothly interpolate to target
      const newX = x + (targetX - x) * lerp;
      const newY = y + (targetY - y) * lerp;

      // Determine direction based on movement
      if (targetX > x + 2) {
        directionRef.current = 1; // Moving right
      } else if (targetX < x - 2) {
        directionRef.current = -1; // Moving left
      }

      // Check if actually moving toward target
      const distToTarget = Math.hypot(newX - targetX, newY - targetY);
      const isNowMoving = mouseMovingRef.current || distToTarget > 2;

      if (posRef.current.isMoving !== isNowMoving) {
        posRef.current.isMoving = isNowMoving;
        if (isNowMoving) {
          frameTimer = 0;
          walkIndex = 0;
          img.src = walkFrames[0];
        } else {
          // Idle: show frame 2
          img.src = frames[1];
        }
      }

      // Alternate between frame 1 and frame 3 while walking
      if (posRef.current.isMoving) {
        frameTimer++;
        footprintTimer++;
        if (frameTimer > 20) { // ~330ms per frame at 60fps
          walkIndex = (walkIndex + 1) % walkFrames.length;
          img.src = walkFrames[walkIndex];
          frameTimer = 0;
        }
        if (footprintTimer > 25) {
          spawnFootprint(newX, newY);
          footprintTimer = 0;
        }
      }

      // Apply transform for direction and position
      hiker.style.transform = `translate(${newX}px, ${newY}px) scaleX(${directionRef.current})`;
      hiker.style.zIndex = '10';

      posRef.current.x = newX;
      posRef.current.y = newY;

      animRef.current = requestAnimationFrame(updatePosition);
    };

    console.log('Starting animation loop. Home position:', homeX, homeY);

    const handleMouseMove = (e) => {
      if (!hero.contains(e.target)) return;

      const rect = hero.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

      posRef.current.targetX = Math.max(0, Math.min(mouseX - hikerWidth / 2, hero.offsetWidth - hikerWidth));
      posRef.current.targetY = Math.max(0, Math.min(mouseY - hikerHeight / 2, hero.offsetHeight - hikerHeight));

      // Mark mouse as moving, clear old timer
      mouseMovingRef.current = true;
      if (mouseTimerRef.current) clearTimeout(mouseTimerRef.current);
      // Stop walking animation after mouse stops, but stay in place
      mouseTimerRef.current = setTimeout(() => {
        mouseMovingRef.current = false;
        // Freeze target at current position so character doesn't drift
        posRef.current.targetX = posRef.current.x;
        posRef.current.targetY = posRef.current.y;
        // Delay bubble by 1.2s after stopping
        bubbleTimeout = setTimeout(() => {
          showBubble(posRef.current.x, posRef.current.y);
        }, 1200);
      }, 150);
    };

    const handleMouseLeave = () => {
      mouseMovingRef.current = false;
      if (mouseTimerRef.current) clearTimeout(mouseTimerRef.current);
      hideBubble();
      posRef.current.targetX = homeX;
      posRef.current.targetY = homeY;
      startAutoWalk();
    };

    const startAutoWalk = () => {
      if (autoWalkTimer) clearTimeout(autoWalkTimer);
      
      let stepsWalked = 0;
      let shouldStopAtPosition = null;
      
      // Decide if we should stop and at what progress
      if (walkProgress > 0.3 && walkProgress < 0.7) {
        // Pick a random stop position after at least minWalkSteps
        shouldStopAtPosition = 0.2 + Math.random() * 0.6; // Random between 0.2 and 0.8
      }
      
      const doWalk = () => {
        if (mouseMovingRef.current) {
          // Reschedule if mouse is over
          autoWalkTimer = setTimeout(doWalk, 100);
          return;
        }
        
        const { badgeLeftX, badgeRightX, badgeCenterY } = getBadgeCoordinates();
        
        stepsWalked++;
        walkProgress += walkStepSize * walkDirection;
        
        // Clamp to boundaries
        if (walkProgress <= 0) {
          walkProgress = 0;
          walkDirection = 1; // Change direction to right
          // Show bubble and resume walk when it dismisses
          showBubble(badgeLeftX + hikerWidth / 2, badgeCenterY, () => {
            autoWalkTimer = setTimeout(doWalk, 100);
          });
          shouldStopAtPosition = null;
          return;
        }
        if (walkProgress >= 1) {
          walkProgress = 1;
          walkDirection = -1; // Change direction to left
          // Show bubble and resume walk when it dismisses
          showBubble(badgeRightX + hikerWidth / 2, badgeCenterY, () => {
            autoWalkTimer = setTimeout(doWalk, 100);
          });
          shouldStopAtPosition = null;
          return;
        }
        
        // Check if we should stop at a random position
        if (shouldStopAtPosition !== null && stepsWalked >= minWalkSteps) {
          if (Math.abs(walkProgress - shouldStopAtPosition) < walkStepSize * 2) {
            // Close enough, stop and show message
            walkProgress = shouldStopAtPosition;
            // Show bubble and resume walk when it dismisses
            showBubble(badgeLeftX + walkProgress * (badgeRightX - badgeLeftX) + hikerWidth / 2, badgeCenterY, () => {
              autoWalkTimer = setTimeout(doWalk, 100);
            });
            shouldStopAtPosition = null;
            return;
          }
        }
        
        // Update target position based on walk progress
        const targetX = badgeLeftX + walkProgress * (badgeRightX - badgeLeftX);
        posRef.current.targetX = targetX;
        posRef.current.targetY = badgeCenterY;
        
        autoWalkTimer = setTimeout(doWalk, 50); // Update every 50ms
      };
      
      doWalk();
    };

    const handleMouseMoveHide = () => { 
      hideBubble();
      if (autoWalkTimer) clearTimeout(autoWalkTimer);
    };
    hero.addEventListener('mousemove', handleMouseMoveHide);

    hero.addEventListener('mousemove', handleMouseMove);
    hero.addEventListener('mouseleave', handleMouseLeave);
    window.addEventListener('resize', handleResize);

    animRef.current = requestAnimationFrame(updatePosition);
    
    // Start auto-walk
    startAutoWalk();

    return () => {
      hero.removeEventListener('mousemove', handleMouseMove);
      hero.removeEventListener('mousemove', handleMouseMoveHide);
      hero.removeEventListener('mouseleave', handleMouseLeave);
      window.removeEventListener('resize', handleResize);
      if (animRef.current) cancelAnimationFrame(animRef.current);
      if (mouseTimerRef.current) clearTimeout(mouseTimerRef.current);
      if (autoWalkTimer) clearTimeout(autoWalkTimer);
      if (bubbleTimeout) clearTimeout(bubbleTimeout);
      if (bubbleEl && bubbleEl.parentNode) bubbleEl.remove();
      footprints.forEach(fp => { if (fp.parentNode) fp.parentNode.removeChild(fp); });
    };
  }, [heroRef]);

  return (
    <div ref={hikerRef} className={styles.hiker}>
      <img 
        ref={imgRef} 
        alt="Hiking character"
        onLoad={() => console.log('Image loaded successfully')}
        onError={(e) => console.error('Image failed to load:', e.target.src)}
      />
    </div>
  );
}
